module.exports = __webpack_public_path__ + "static/media/Playlist-Script.f47249be.svg";